<mat-card class="p-0">
  <div class="search-row" *ngIf="producer$ | async">
    <rtl2-search
      foreground="dark"
      color="light"
      [placeholder]="'list.searchPlaceholder.title' | translate"
      [search]="queryTitle$ | async"
      (searchChange)="searchFormat($event)"
    ></rtl2-search>
  </div>

  <div class="search-row">
    <rtl2-search
      [class.no-search-button]="producer$ | async"
      class="no-search-button"
      foreground="dark"
      color="light"
      [placeholder]="'list.searchPlaceholder.mazId' | translate"
      [search]="queryMaz$ | async"
      (searchChange)="searchMaz($event)"
    ></rtl2-search>
  </div>

  <mat-progress-bar
    mode="indeterminate"
    [class.hidden]="!(loading$ | async)"
    color="accent"
  ></mat-progress-bar>
</mat-card>
